import { ExternalDeliveryProvider, ExternalDeliveryProviders } from 'src/constants/ExternalDeliveryProviders';

export function isRappiCargoExternalDeliveryProvider(deliveryProvider?: ExternalDeliveryProvider): boolean {
    return deliveryProvider === ExternalDeliveryProviders.RAPPI_CARGO;
}
